<template>
  <div>
    <a-modal
      :title="courseDetail.courseName"
      :maskClosable="false"
      :width="1200"
      :visible="visible"
      :confirmLoading="confirmLoading"
      :cancelText="'取消'"
      :okText="'确定'"
      @cancel="handleCancel"
      :footer="null"
    >
      <div class="institution-info">
        <div><span class="name">班级信息</span></div>
        <div>
          <span class="key">班级名称：</span>
          <span class="value">{{ courseDetail.className }}</span>
        </div>
        <div>
          <span class="key">上课计划：</span>
          <span class="value class-time">
            <div
              v-for="(item, index) in courseDetail.teachingPlanList"
              :key="index"
            >
              <span>{{ item.classWeeks | weekName }}&nbsp;&nbsp;</span>
              <span>{{ item.classTime }}</span>
            </div>
          </span>
        </div>
        <div>
          <span class="key">上课日期：</span>
          <span class="value"
            >{{ courseDetail.startTime
            }}{{ courseDetail.endTime ? '~' + courseDetail.endTime : '' }}</span
          >
        </div>
        <div>
          <span class="key">上课地点：</span>
          <span class="value">{{ courseDetail.placeName }}</span>
        </div>
        <div>
          <span class="key">上课老师：</span>
          <span class="value">{{ courseDetail.teacherName }}</span>
        </div>
        <div>
          <span class="key">课程提供方：</span>
          <span class="value">{{ courseDetail.providerName }}</span>
        </div>
        <div class="makeUp">
          <div><span class="name gap">课节目录</span></div>

          <div>
            <a-button @click="showModal"> 补课 </a-button>
            <a-modal v-model="visible1" title="" @ok="handleOk">
              <a-form :layout="formLayout">
                <a-tabs
                  default-active-key="1"
                  @change="callback"
                  style="boder-bottom: none"
                >
                  <a-tab-pane key="scheduleId">
                    <span slot="tab">
                      <a-icon type="check-circle" />
                      自有课程
                    </span>

                    <a-form-item
                      label="补课方式"
                      :label-col="formItemLayout.labelCol"
                      :wrapper-col="formItemLayout.wrapperCol"
                    >
                      <a-select
                        placeholder="请选择"
                        v-decorator="[
                          'lessonId',
                          { rules: [{ required: true, message: '请选择' }] },
                        ]"
                      >
                        <a-select-option
                          v-for="(item, index) in lessonList"
                          :key="index"
                          :value="item.id"
                          >{{ item.lessonName }}</a-select-option
                        >
                      </a-select>
                    </a-form-item>

                    <a-form-item
                      label="补课日期"
                      :label-col="formItemLayout.labelCol"
                      :wrapper-col="formItemLayout.wrapperCol"
                    >
                      <a-date-picker
                        format="YYYY-MM-DD"
                        style="width: 100%"
                        :disabledDate="disabledDate_attendDate"
                        v-decorator="[
                          'attendDate',
                          { rules: [{ required: true, message: '请选择' }] },
                        ]"
                      />
                    </a-form-item>
                    <a-form-item
                      label="补课时间"
                      :label-col="formItemLayout.labelCol"
                      :wrapper-col="formItemLayout.wrapperCol"
                    >
                      <a-range-picker
                        :show-time="{ format: 'HH:mm' }"
                        format="YYYY-MM-DD HH:mm"
                        :placeholder="['Start Time', 'End Time']"
                        @change="onChange"
                        @ok="onOk"
                      />
                    </a-form-item>
                  </a-tab-pane>
                  <a-tab-pane key="2">
                    <span slot="tab">
                      <a-icon type="check-circle" />
                      新建课程
                    </span>

                    <a-form-item
                      label="新建课节"
                      :label-col="formItemLayout.labelCol"
                      :wrapper-col="formItemLayout.wrapperCol"
                    >
                      <a-input
                        placeholder="请输入课程"
                        v-decorator="[
                          'lessonName',
                          {
                            rules: [{ required: true, message: '请输入课程' }],
                          },
                        ]"
                      />
                    </a-form-item>
                    <a-form-item
                      label="补课日期"
                      :label-col="formItemLayout.labelCol"
                      :wrapper-col="formItemLayout.wrapperCol"
                    >
                      <a-date-picker
                        format="YYYY-MM-DD"
                        style="width: 100%"
                        :disabledDate="disabledDate_attendDate"
                        v-decorator="[
                          'attendDate',
                          { rules: [{ required: true, message: '请选择' }] },
                        ]"
                      />
                    </a-form-item>
                    <a-form-item
                      label="补课时间"
                      :label-col="formItemLayout.labelCol"
                      :wrapper-col="formItemLayout.wrapperCol"
                    >
                      <a-range-picker
                        :show-time="{ format: 'HH:mm' }"
                        format="YYYY-MM-DD HH:mm"
                        :placeholder="['Start Time', 'End Time']"
                        @change="onChange"
                        @ok="onOk"
                      />
                    </a-form-item>
                  </a-tab-pane>
                </a-tabs>
              </a-form>
            </a-modal>
          </div>
        </div>

        <div class="lesson-table">
          <div class="header">
            <span class="cell time">日期/周期</span>
            <span class="cell">上课课节</span>
            <span class="cell">课节名称</span>
            <span class="cell">课节码</span>
            <span class="cell">上课时间段</span>
            <span class="cell">老师出勤</span>
            <span class="cell cell_2">学生点名<br />总人数/实到/请假</span>
            <span class="cell">状态</span>
            <span class="cell cell_oper">操作</span>
          </div>
          <div
            class="row"
            v-for="(item, index) in courseDetail.lessonList"
            :key="index"
          >
            <span class="cell time">{{
              moment(item.attendDate).format('YYYY-MM-DD 周dd')
            }}</span>
            <span class="cell">第{{ index + 1 }}节课</span>
            <span class="cell">{{ item.lessonName }}</span>
            <span class="cell">{{ item.courseCode }}</span>
            <span class="cell">{{ item.classTime }}</span>
            <span class="cell">{{ item.teacherCheckinStatusText }}</span>
            <span class="cell cell_2_content"
              >{{ item.totalCount }}/{{ item.checkinCount }}/{{
                item.absenceCount
              }}</span
            >
            <span class="cell">{{ item.statusText }}</span>
            <span class="cell cell_oper">
              <span
                class="oper hover-font-active"
                @click="$refs.courseDetail.init(item)"
                >详情</span
              >
              <template v-if="item.scheduleId">
                <span
                  class="oper hover-font-active"
                  @click="updateTime(item)"
                  v-if="item.status != 1"
                  >修改</span
                >
                <span
                  class="oper hover-font-active"
                  @click="postpone(item, index)"
                  v-if="item.status != 1"
                  >顺延</span
                >
              </template>
            </span>
          </div>
        </div>
      </div>
    </a-modal>
    <a-modal
      title="修改课节"
      :maskClosable="false"
      :width="500"
      :visible="visible_inner"
      :cancelText="'取消'"
      :okText="'确定'"
      @cancel="handleCancel_inner"
      @ok="handleSubmit_inner"
    >
      <a-form class="class-form" layout="horizontal" :form="form">
        <a-form-item
          class="update-time-form"
          label="课程名称"
          :labelCol="{ lg: { span: 7 } }"
          :wrapperCol="{ lg: { span: 13 } }"
        >
          <span>{{ updateObj.courseName }}</span>
        </a-form-item>
        <a-form-item
          class="update-time-form"
          label="课节码"
          :labelCol="{ lg: { span: 7 } }"
          :wrapperCol="{ lg: { span: 13 } }"
        >
          <span>{{ updateObj.courseCode }}</span>
        </a-form-item>
        <!-- 开班日期 -->
        <a-form-item
          label="开班日期"
          class="update-time-form"
          :labelCol="{ lg: { span: 7 } }"
          :wrapperCol="{ lg: { span: 13 } }"
        >
          <a-date-picker
            format="YYYY-MM-DD"
            style="width: 100%"
            :disabledDate="disabledDate_attendDate"
            v-decorator="[
              'attendDate',
              { rules: [{ required: true, message: '请选择' }] },
            ]"
          />
        </a-form-item>
        <a-form-item
          class="update-time-form"
          label="上课时间"
          :labelCol="{ lg: { span: 7 } }"
          :wrapperCol="{ lg: { span: 13 } }"
        >
          <a-select placeholder="请选择">
            <a-select-option
              v-for="(item, index) in toClassList"
              :key="index"
              :value="item.startTime + '-' + item.endTime"
              >{{ item.startTime }} ~ {{ item.endTime }}</a-select-option
            >
          </a-select>
        </a-form-item>
      </a-form>
    </a-modal>

    <course-detail-modal ref="courseDetail"></course-detail-modal>
  </div>
</template>

<script>
import education from '../../../api/education'
import classSet from '../../../api/classSet'
import CourseDetailModal from './../CourseDetailModal'
import moment from 'moment'

import utils from '../../../utils'

import Vue from 'vue'

export default {
  name: 'AttendanceDetailModal',
  data() {
    return {
      visible: false,
      visible_inner: false,
      confirmLoading: false,
      courseDetail: {},
      form: this.$form.createForm(this),
      toClassList: [], //上课时间段
      updateObj: {}, //修改的对象
      visible1: false, //补课
      formLayout: 'horizontal',
      lessonName: {},
      lessonList: [],
      classTime: '',
      lessonName: [],
      lessonType: 0,
      scheduleId: {},
      lessonId: 0,
      classId: 0,
      attendDate: '2021-07-22',
      form: {
        name: '',
        region: undefined,
        date1: undefined,
        date2: undefined,
        delivery: false,
        type: [],
        resource: '',
        desc: '',
      },
    }
  },
  components: {
    CourseDetailModal,
  },
  computed: {
    //补课
    formItemLayout() {
      const { formLayout } = this
      return formLayout === 'horizontal'
        ? {
            labelCol: {
              span: 4,
            },
            wrapperCol: {
              span: 14,
            },
          }
        : {}
    },
    buttonItemLayout() {
      const { formLayout } = this
      return formLayout === 'horizontal'
        ? {
            wrapperCol: {
              span: 14,
              offset: 4,
            },
          }
        : {}
    },
  },
  methods: {
    //补课
    setTagIdNull() {},

    handleFormLayoutChange(e) {
      this.formLayout = e.target.value
    },

    callback(key) {
      console.log(key)
    },
    showModal() {
      this.visible1 = true
    },
    handleOk(e) {
      console.log(e)
      this.visible1 = false
      this.makeUpMissedLessons()
    },
    //自有课程

    // 补课

    makeUpMissedLessons() {
      return new Promise((resolve) => {
        let req = {
          attendDate: this.attendDate,
          classId: this.classId,
          classTime: this.classTime,
          lessonId: this.lessonId,
          lessonType: this.lessonType,
          lessonName: this.lessonName,
        }
        education.makeUpMissedLessons(req).then((res) => {
          // this.makeUpMissedLessons = res.data;
          this.attendDate = res.data.attendDate
          this.classId = res.data.id
          this.classTime = res.data.classTime
          this.lessonId = res.data.lessonId
          this.lessonType = res.data.lessonType
          this.lessonName = res.data.lessonName
          this.scheduleId = res.data.scheduleId
          resolve(res.data)
        })
      })
    },
    //补课时间
    onChange(value, dateString) {
      console.log('Selected Time: ', value)
      console.log('Formatted Selected Time: ', dateString)
    },
    onOk(value) {
      console.log('onOk: ', value)
    },

    //获取选课时间的List
    // lessonType() {
    // 	console.log(this.toClassList);
    // 	let req = {
    // 		lessonType: "0",
    // 	};
    // 	education.makeUpMissedLessons(req).then((res) => {
    // 		this.lessonType = res.data;
    // 	});
    // },

    moment,
    //开班_禁用日
    disabledDate_attendDate(current) {
      return (
        current &&
        current <= moment(moment().format('YYYY-MM-DD') + ' 00:00:00')
      )
    },

    //获取选课时间的List
    getClassTimeList() {
      console.log(this.toClassList)
      education.getClassTimeList().then((res) => {
        this.toClassList = res.data
      })
    },

    //修改上课时间
    updateTime(value) {
      this.visible_inner = true
      this.updateObj = value

      let formData = {}
      formData.classTime = value.classTime
      formData.attendDate = moment(value.attendDate)
      console.log(formData)
      setTimeout(() => {
        this.form.setFieldsValue(formData)
      }, 100)
    },

    //取消上课时间弹窗
    handleCancel_inner() {
      this.visible_inner = false
    },

    //修改上课时间-确认
    handleSubmit_inner() {
      this.form.validateFields((err, value) => {
        //校验通过
        if (!err) {
          let req = {
            attendDate: moment(value.attendDate).format('YYYY-MM-DD'),
            classTime: value.classTime,
          }
          education
            .updateClassTime(this.updateObj.scheduleId, req)
            .then((res) => {
              this.$message.success('修改成功')
              this.getAfterSchool(this.courseId)
              this.handleCancel_inner()
            })
        }
      })
    },

    //初始化，显示
    init(detail = {}) {
      console.log(detail)
      this.courseId = detail.id
      this.visible = true
      this.getAfterSchool()
      this.getClassTimeList()
    },

    //延课
    postpone(item, index) {
      let self = this
      this.$confirm({
        title: '确定要顺延吗?',
        okText: '确定',
        cancelText: '取消',
        content: '顺延后，无法撤销',
        onOk() {
          education.postpone(item.scheduleId).then((res) => {
            self.getAfterSchool(self.courseId)
            self.$message.success('顺延成功')
          })
        },
      })
    },

    //查询放假信息：信息 + 课表列表
    getAfterSchool() {
      education.getClassDetail(this.courseId).then((res) => {
        this.courseDetail = res.data
        this.lessonList = this.courseDetail.lessonList
        console.log('课节目录：', res.data)
      })
    },

    //隐藏
    handleCancel() {
      this.visible = false
      this.$emit('closeForm')
    },
  },
}
</script>
<style lang="scss" scoped>
@import 'src/config/var';

.institution-info {
  text-align: left;
  height: calc(100vh - 180px);
  overflow-y: auto;
  overflow-x: hidden;

  div {
    font-size: 16px;
    line-height: 32px;

    .gap {
      margin-top: 20px;
      display: block;
    }

    .name {
      font-size: 16px;
      font-weight: 500;
      color: $normal-color;
    }

    .key {
      display: inline-block;
      font-weight: 600px;
      color: $normal-color-light;
      width: 130px;
      text-align: right;
    }

    .value {
      color: $normal-color-dark;
      padding-left: 6px;
      display: inline-block;
      padding-right: 16px;
      text-align: left;

      img {
        width: 100px;
        height: 100px;
        vertical-align: top;
        position: relative;
        top: 10px;
      }
    }

    .oper {
      color: $primary-color-dark;
      cursor: pointer;
    }

    .intro {
      width: 100%;
      padding: 0px 20px;
      display: inline-block;
      color: $normal-color-dark;
    }
  }

  .update-oper {
    text-align: center;
  }
}

.institution-check {
  padding-top: 10px;
  border-top: 1px solid $border-color;
  margin-top: 16px;
  text-align: center;
}

.check-confirm {
  margin-top: 16px;

  textarea {
    width: 300px;
    margin-left: 376px;
    vertical-align: middle;
    margin-right: 8px;
  }
}

.show-image-outer {
  position: fixed;
  top: 0px;
  bottom: 0px;
  left: 0px;
  right: 0px;
  z-index: 999999;

  .show-image-bg {
    width: 100%;
    height: 100vh;
    background: black;
    opacity: 0.5;
    z-index: 1000000;
    cursor: pointer;
  }

  img {
    cursor: pointer;
    position: fixed;
    top: 10vh;
    height: 80vh;
    margin-left: 50%;
    transform: translateX(-50%);
    z-index: 1000001;
    text-align: center;
  }
}

//课节目录
.lesson-table {
  margin: 10px 20px;
  border-left: 1px solid $border-color;
  border-bottom: 1px solid $border-color;

  .cell {
    border-right: 1px solid $border-color;
    border-top: 1px solid $border-color;
    display: inline-block;
    width: calc((100% - 150px - 150px - 140px) / 6);
    min-height: 34px;
    line-height: 34px;
    text-align: center;
    vertical-align: top;
    font-size: 14px;
  }

  .time {
    width: 150px !important;
  }

  .cell_2_content {
    width: 150px !important;
  }

  > .header {
    .cell {
      font-weight: 500;
      line-height: 50px;
      height: 50px !important;
      color: $normal-color;
    }

    .cell_2 {
      width: 150px;
      line-height: 20px !important;
    }
  }

  .row {
    .oper {
      color: $primary-color;
      display: inline-block;
      padding: 0px 4px;
    }
  }
}

.cell_oper {
  width: 140px !important;
}

.update-time-form {
  margin-bottom: 10px !important;
}

.class-time {
  vertical-align: top;
}

.makeUp {
  display: flex;
  justify-content: space-between;
}

.btn {
  border-radius: 0.5rem;
  border: 1px solid #ccc;
  padding: 0 0.825rem;
}

// 补课
.ant-modal-wrap {
  width: 20%;
}

.ant-tabs-nav-scroll {
  border-bottom: none;
}
</style>
